import { createSlice } from '@reduxjs/toolkit'

/**
 * store slice 
 */
export const popupDataSlice = createSlice({
  name: 'popupData',
  initialState: {
    mapLink: null,
    inputLocation: null,
    physicalStores: null,
    selectedStore: null,
    clickedStore: null,
  },
  reducers: {
    openPopup: (state, action) => {
      const mapLink = action.payload;
      return { ...state, mapLink: mapLink }
    },
    saveInputLocation: (state, action) => {
      return { ...state, inputLocation: action.payload }
    },
    savePhysicalStores: ( state, action ) => {
      const stores = action.payload;
      return { ...state, physicalStores: stores, selectedStore: stores[0], mapLink: stores[0].x_staticMapImage}
    },
    selectStore: (state, action) => {
      const store = action.payload;
      return { ...state, selectedStore: store, mapLink: store.x_staticMapImage }
    },
    changeLocation: (state, action) => {
      const mapLink = action.payload;
      return { ...state, inputLocation: null, selectedStore: null, physicalStores: null, mapLink: mapLink }
    },
    closePopup: (state) => {
      return { ...state, mapLink: null, inputLocation: null, selectedStore: null, physicalStores: null, clickedStore: null }
    },
    setClickedStore: (state, action) => {
      return { ...state, clickedStore: action.payload }
    },
  },
});

export const { openPopup, saveInputLocation, savePhysicalStores, selectStore, changeLocation, closePopup, setClickedStore } = popupDataSlice.actions;
export default popupDataSlice.reducer

